import { useContext } from 'react'

import { CompaniesContext } from '@/contexts/companies'

export function useCompanies() {
  return useContext(CompaniesContext)
}
